import { Client } from '@stomp/stompjs'
import SockJS from 'sockjs-client'

let stompClient: Client | null = null

export function getStompClient() {
  const wsUrl = process.env.NEXT_PUBLIC_WS_URL

  if (!stompClient) {
    stompClient = new Client({
      webSocketFactory: () =>
        new SockJS(wsUrl || 'https://moveis.decormaredu.com.br/ws'),
      reconnectDelay: 5000,
    })
  }
  return stompClient
}
